import React from "react";
import { Input } from "../AllInput/AllInput";
import { IconSearch } from "../../assests/icons/MapToolsIcons";
import { NewIconSearch } from "../../assests/icons/EPCIcons/Icons";


interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  width?: boolean;
  disabled?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder ,width, disabled = false }) => {
  return (
    <div className={`w-full -mt-2 relative pt-2 ${width?"":"md:w-64"}`}>
      <Input smpadding preicon={<NewIconSearch size={12} />} id="chatSearch" name="chatSearch" type="text" value={value} disabled={disabled} onChange={onChange} placeholder={placeholder || "Search..."}  />
      {/* <span className="absolute left-1 top-1/2 top-handle mt-1 -translate-y-1/2 text-gray-600 flex-shrink-0">
        <IconSearch />
      </span> */}
    </div>
  );
};

export default SearchBar;
